import { render, staticRenderFns } from "./top-level.vue?vue&type=template&id=269fbd53&scoped=true&lang=pug&"
import script from "./top-level.vue?vue&type=script&lang=coffee&"
export * from "./top-level.vue?vue&type=script&lang=coffee&"
import style0 from "./top-level.vue?vue&type=style&index=0&id=269fbd53&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269fbd53",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default,SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
